<div class="change-partner-dialog-container" fxLayout="column" fxLayoutGap="15px">
  <h3>
    Przepięcie OFWCA tutaj zmien
  </h3>

  <mat-form-field>
    <mat-label>Rodzaj przepięcia</mat-label>
    <mat-select [formControl]="withWalletControl">
      <mat-option [value]="true">Przepnij z portfelem</mat-option>
      <mat-option [value]="false">Przepnij bez portfela</mat-option>
    </mat-select>
  </mat-form-field>

  <div fxLayout="row">
    <div *ngIf="!withWalletControl.value">
      <ul class="change-partner-description">
        <li>Wyrejestrowujemy OFWCA w KNF, archiwalne dostępy sprzedażowe pozostają pod starym Partnerem.</li>
        <li>Rejestrujemy ponownie OFWCA w celu nadania jej nowych dostępów sprzedażowych pod nowym Partnerem.</li>
        <li>Oddzielenie sprzedaży rozróżniane jest różnymi dostępami sprzedażowymi (identyfikatorami).</li>
      </ul>
    </div>

    <div *ngIf="withWalletControl.value" fxLayoutGap="15px" fxLayout="column">
      <ul class="change-partner-description">
        <li>Przepinamy w całości OFWCA wraz z rejestracjami pod nowego Partnera.</li>
        <li>Sprzedaż w całości (wraz z ratami oraz wznowieniami automatycznymi) naliczana będzie od momentu przepięcia pod nowego Partnera.</li>
        <li>W celu dokonania przepięcia portfela z jednego Partnera na drugiego Partnera należy podpisać dokument porozumienia.</li>
      </ul>

      <mat-slide-toggle labelPosition="after" [formControl]="withCommissionRedirectionsControl">
        Czy przenosimy przepięcia polis na nowego Partnera?
      </mat-slide-toggle>

      <mat-radio-group [formControl]="partnerOfwcaControl" fxLayoutGap="15px">
        <mat-radio-button [value]="false" > Partner </mat-radio-button><br>
        <mat-radio-button [value]="true" > OFWCA </mat-radio-button>
      </mat-radio-group>

    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <app-detail
      header="Z Partnera" fxFlex="50"
      class="change-partner-dialog-control"
    >
      {{ofwcaObject.partner?.shortName}}
    </app-detail>

    <app-dict-partners
      label="Na Partnera" fxFlex="50"
      [required]="true" fxLayoutAlign="space-around end"
      [control]="newPartnerControl"
    ></app-dict-partners>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" class="change-partner-dialog-tags" >
    <app-detail header="" fxFlex="50">
      <mat-chip-list>
        <ng-container *ngFor="let tag of ofwcaObject?.partner?.tags; let last = last">
          <mat-chip color="accent" selected>{{ tag.name }}</mat-chip>
        </ng-container>
      </mat-chip-list>
    </app-detail>

    <app-detail header="" fxFlex="50">
      <mat-chip-list *ngIf="newPartnerControl.value">
        <ng-container *ngFor="let tag of newPartnerObject?.tags; let last = last">
          <mat-chip color="accent" selected>{{ tag.name }}</mat-chip>
        </ng-container>
      </mat-chip-list>
    </app-detail>
  </div>

  <div fxLayout="column" *ngIf="withWalletControl.value">
    <div fxLayout="row" fxFlex="100">
      <span fxFlex></span>
      <mat-slide-toggle labelPosition="before" [formControl]="showAllContracts">Pokaż wszystkie umowy</mat-slide-toggle>
    </div>

    <div fxLayout="row" fxLayoutGap="15px" *ngFor="let newContractForm of newContractForms">
      <app-detail
        header="Z umowy" fxFlex="50"
        class="change-partner-dialog-control"
      >
        <h4>
          <ng-container *ngIf="newContractForm.currentContract.partner">
            {{newContractForm.currentContract.partner?.shortName}},
          </ng-container>
          <ng-container *ngIf="newContractForm.currentContract.ofwca">
            {{newContractForm.currentContract.ofwca.fullName}},
          </ng-container>
          {{ newContractForm.currentContract.type.name }} (nr: {{newContractForm.currentContract.number}})
        </h4>
        <div class="change-partner-dialog-contract-details">
          Zawarta {{newContractForm.currentContract.concludeDate | date:'y-MM-dd'}},
          Status: {{newContractForm.currentContract.status.name}}
        </div>
        <div class="change-partner-dialog-contract-details">
          Firma: {{newContractForm.currentContract.company.name}}
        </div>
      </app-detail>

      <app-dict-contracts
        *ngIf="!showAllContracts.value && !partnerOfwcaControl.value"
        [partnerId]="newPartnerControl.valueChanges"
        label="Na umowę" fxFlex="50"
        [required]="true" fxLayoutAlign="space-around end"
        [control]="newContractForm.newContractControl"
        [initializeWith]="newPartnerControl.value"
        [partnerContractsChange]="true"
        [companyId]="newContractForm.currentContract.company?.id"
      ></app-dict-contracts>

      <app-dict-contracts
        *ngIf="!showAllContracts.value && partnerOfwcaControl.value"
        label="Na umowę" fxFlex="50"
        [control]="newContractForm.newContractControl"
        [required]="true" fxLayoutAlign="space-around end"
        [contracts]="ofwcaContracts"
        [showOwnerName]="true"
        [showStatus]="true"
        [partnerContractsChange]="true"
        [companyId]="newContractForm.currentContract.company?.id"
     ></app-dict-contracts>

      <app-dict-all-contracts
        *ngIf="showAllContracts.value && partnerOfwcaControl.value"
        label="Na umowę" fxFlex="50"
        [required]="true" fxLayoutAlign="space-around end"
        [control]="newContractForm.newContractControl"
        [partnerContractsChangeOfwca]="true"
        [companyId]="newContractForm.currentContract.company?.id"
      ></app-dict-all-contracts>

      <app-dict-all-contracts
        *ngIf="showAllContracts.value && !partnerOfwcaControl.value"
        label="Na umowę" fxFlex="50"
        [required]="true" fxLayoutAlign="space-around end"
        [control]="newContractForm.newContractControl"
        [partnerContractsChange]="true"
        [companyId]="newContractForm.currentContract.company?.id"
      ></app-dict-all-contracts>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <app-detail
      header="Z placówki" fxFlex="50"
      class="change-partner-dialog-control"
    >
      {{ofwcaObject.facility?.address?.searchString}}
    </app-detail>

    <app-partner-facility-select
      label="Na placówkę" fxFlex="50"
      [required]="true" fxLayoutAlign="space-around end"
      [control]="newFacilityControl"
      [partnerId]="newPartnerControl.valueChanges"
    ></app-partner-facility-select>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <a
      *ngIf="withWalletControl.value"
      href="/rest/crm/static/doc/Porozumienie_dot_przepiecia_portfela.docx"
      target="_blank" mat-stroked-button color="primary"
    >
      <mat-icon>file_download</mat-icon>
      <span> Porozumienie dot. przepięcia portfela</span>
    </a>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !changePartnerFormValid"
    >Zapisz</button>
  </div>
</div>
